import React from 'react';
import { Award, Briefcase, Users, TrendingUp } from 'lucide-react';

const Stats = () => {
  const stats = [
    {
      icon: Briefcase,
      value: '8+',
      label: 'Years of Excellence',
      description: 'Industry expertise'
    },
    {
      icon: Award,
      value: '500+',
      label: 'Projects Delivered',
      description: 'Successfully completed'
    },
    {
      icon: Users,
      value: '3',
      label: 'Industry Verticals',
      description: 'Specialized expertise'
    },
    {
      icon: TrendingUp,
      value: '100%',
      label: 'Client Satisfaction',
      description: 'Results-driven approach'
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: "'Crimson Text', serif" }}>
            Proven Track Record
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Numbers that speak for themselves. Delivering exceptional results across industries with data-driven strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div 
                key={index}
                className="bg-[#e6e67c] rounded-xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:translate-y-[-4px] border-2 border-transparent hover:border-black"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-black rounded-full mb-6">
                  <Icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-5xl font-bold mb-2" style={{ fontFamily: "'Crimson Text', serif" }}>
                  {stat.value}
                </h3>
                <p className="text-lg font-semibold text-gray-900 mb-2">
                  {stat.label}
                </p>
                <p className="text-sm text-gray-700">
                  {stat.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats;
